(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["how-it-works"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var sections = document.querySelectorAll('[data-pills-section]');
    sections.forEach(function(section) {
      var triggers = section.querySelectorAll('[data-pill-trigger]');
      var panels = section.querySelectorAll('[data-pill-panel]');

      triggers.forEach(function(trigger) {
        trigger.addEventListener('click', function() {
          var idx = trigger.dataset.pillTrigger;

          triggers.forEach(function(t) { t.classList.remove('is-active'); });
          panels.forEach(function(p) { p.classList.remove('is-active'); });

          trigger.classList.add('is-active');
          var target = section.querySelector('[data-pill-panel="' + idx + '"]');
          if (target) target.classList.add('is-active');
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["problem-education"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var sections = document.querySelectorAll('[data-pills-section]');
    sections.forEach(function(section) {
      if (section.dataset.pillsBound) return;
      section.dataset.pillsBound = '1';
      var triggers = section.querySelectorAll('[data-pill-trigger]');
      var panels = section.querySelectorAll('[data-pill-panel]');

      triggers.forEach(function(trigger) {
        trigger.addEventListener('click', function() {
          var idx = trigger.dataset.pillTrigger;
          triggers.forEach(function(t) { t.classList.remove('is-active'); });
          panels.forEach(function(p) { p.classList.remove('is-active'); });
          trigger.classList.add('is-active');
          var target = section.querySelector('[data-pill-panel="' + idx + '"]');
          if (target) target.classList.add('is-active');
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-hero"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('[data-gallery]').forEach(function(gallery) {
      if (gallery.dataset.galleryBound) return;
      gallery.dataset.galleryBound = '1';
      var slides = gallery.querySelectorAll('[data-image-index]');
      var thumbs = gallery.querySelectorAll('[data-thumb-index]');
      var counter = gallery.querySelector('[data-gallery-counter]');
      var total = slides.length;

      function show(idx) {
        slides.forEach(function(s) {
          s.classList.toggle('is-active', Number(s.dataset.imageIndex) === idx);
        });
        thumbs.forEach(function(t) {
          t.classList.toggle('is-active', Number(t.dataset.thumbIndex) === idx);
        });
        if (counter) {
          var n = String(idx + 1).padStart(2, '0');
          counter.innerHTML = n + ' <span>/ ' + String(total).padStart(2, '0') + '</span>';
        }
      }

      thumbs.forEach(function(thumb) {
        thumb.addEventListener('click', function() {
          show(Number(thumb.dataset.thumbIndex));
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reveal"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('[data-pills-section]').forEach(function(section) {
      if (section.dataset.pillsBound) return;
      section.dataset.pillsBound = '1';
      var triggers = section.querySelectorAll('[data-pill-trigger]');
      var panels = section.querySelectorAll('[data-pill-panel]');
      triggers.forEach(function(trigger) {
        trigger.addEventListener('click', function() {
          var idx = trigger.dataset.pillTrigger;
          triggers.forEach(function(t) { t.classList.remove('is-active'); });
          panels.forEach(function(p) { p.classList.remove('is-active'); });
          trigger.classList.add('is-active');
          var target = section.querySelector('[data-pill-panel="' + idx + '"]');
          if (target) target.classList.add('is-active');
        });
      });
    });

  })();

  } catch(e) { console.error(e); }
})();
})();
